import svc from "../../services/PollPortalService";
import mapper from "../../services/ModelMapperService";

export const DISMISS_ERROR_ALERT = "pollPortal/DISMISS_ERROR_ALERT";
export const GET_POLL_ASSIGNMENT_DETAIL_SUCCESS = "pollPortal/GET_POLL_ASSIGNMENT_DETAIL_SUCCESS";
export const GET_POLL_ASSIGNMENT_DETAIL_FAIL = "pollPortal/GET_POLL_ASSIGNMENT_DETAIL_FAIL";
export const GET_POLL_ASSIGNMENT_TOKEN_SUCCESS = "pollPortal/GET_POLL_ASSIGNMENT_TOKEN_SUCCESS";
export const GET_POLL_ASSIGNMENT_TOKEN_FAIL = "pollPortal/GET_POLL_ASSIGNMENT_TOKEN_FAIL";
export const POSTING_POLL_RESPONSE = "pollPortal/POSTING_POLL_RESPONSE";
export const SUBMIT_POLL_RESPONSE_SUCCESS = "pollPortal/SUBMIT_POLL_RESPONSE_SUCCESS";
export const SUBMIT_POLL_RESPONSE_FAIL = "pollPortal/SUBMIT_POLL_RESPONSE_FAIL";
export const UPDATE_POLL_RESPONSE = "pollPortal/UPDATE_POLL_RESPONSE";


export function dismissErrorAlert() {
    return {type: DISMISS_ERROR_ALERT};
}

export function getPollPortalToken(nonce) {
    return dispatch => svc.getPollAssignmentToken(nonce)
        .then((token) => {
            dispatch({type: GET_POLL_ASSIGNMENT_TOKEN_SUCCESS, token: token});
        })
        .catch((error) => dispatch({type: GET_POLL_ASSIGNMENT_TOKEN_FAIL, error: JSON.stringify(error.stack) }));
}

export function getPollAssignment() {
    return function (dispatch) {
        return svc.getPollAssignment()
            .then(pollAssignment => {
                if (pollAssignment.httpStatusCode === 304) {
                    // 304 means user has already submitted a response - just show the success page
                    dispatch({type: GET_POLL_ASSIGNMENT_DETAIL_SUCCESS, pollAssignment: {}});
                    dispatch({type: SUBMIT_POLL_RESPONSE_SUCCESS, saveResult: pollAssignment});
                } else {
                    const mappedPollAssignment = mapper.mapPollAssignment(pollAssignment);
                    dispatch({type: GET_POLL_ASSIGNMENT_DETAIL_SUCCESS, pollAssignment: mappedPollAssignment});
                }
            })
            .catch(error => dispatch({
                type: GET_POLL_ASSIGNMENT_DETAIL_FAIL,
                error: JSON.stringify(error.stack)
            }));
    };
}

export function setPosting() {
    return {type: POSTING_POLL_RESPONSE};
}

export function submitPollResponse(pollDetails) {
    return (dispatch) => {
        dispatch(setPosting());
        return svc.submitPollResponse(pollDetails)
            .then((result) => {
                dispatch({type: SUBMIT_POLL_RESPONSE_SUCCESS, saveResult: result});
            })
            .catch(err => dispatch({type: SUBMIT_POLL_RESPONSE_FAIL, err}));
    };
}
